// extracted by mini-css-extract-plugin
export default {"container":"PreScannedPage_container__THmvm","box":"PreScannedPage_box__PI7SA","closeButton":"PreScannedPage_closeButton__Q5z0l"};